module.exports = __webpack_public_path__ + "img/icon_sm_khyssp.c768b37b.png";